/**
 * Action filters
 *
 * Keep in mind that actions filters are complex, and this isn't the only component that renders them. Make sure you
 * check how changes to methods that return TemplateResults will affect action filters inside loops.
 */

// Import dependencies
import './condition';

import { AutomatorActionFilterBase } from '@automator/features/page-logs/components/log-filter/_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-loop-action-filter' )
export class AutomatorLoopActionFilter extends AutomatorActionFilterBase {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Creates the template that shows the conditions
	 *
	 * @return {TemplateResult} The conditions
	 */
	get _templateConditions() {
		return html`
			<div class="conditions">
				${ repeat(
					this.conditions,
					item => item.id,
					condition => html`
						<uap-log-loop-action-filter-condition
							condition-id=${ condition.id }
							condition-code=${ condition.code }

							integration-code=${ condition.integration_code }

							.titleHTML=${ condition.title_html }
							.fields=${ condition.fields }
						></uap-log-loop-action-filter-condition>
					`
				) }
			</div>
		`;
	}

	/**
	 * Creates the section that shows all the actions
	 *
	 * @return {TemplateResult} The actions
	 */
	get _templateItems() {
		return html`
			<div class="filter-block-items">
				${ repeat(
					this.items,
					item => item.id,
					item => html`
						<uap-log-loop-action 
							item-id=${ item.id }
							item-code=${ item.code }

							integration-code=${ item.integration_code }
							
							.titleHTML=${ item.title_html }
							.fields=${ item.fields }
							.runs=${ item.runs }

							.status=${ item.status }

							?import-mode=${ this.isImportMode }

							?is-open=${ this.sidebarSourceID === `item-${ item.id }` }
						></uap-log-loop-action>
					`
				) }
			</div>
		`;
	}
}